module.exports = __webpack_public_path__ + "img/entire_house.3b51eac4.svg";